import {
  DepositMethod,
  WithdrawMethod,
  DepositRouteEnum,
  AccountRouteEnum,
  WithdrawRouteEnum,
} from '~/enums'
import type {
  AccountUserOverviewMenu,
  DepositMethodMenu,
} from '~/types/deposit'

export const DEPOSIT_METHOD_MENUS: DepositMethodMenu[] = [
  {
    method: DepositMethod.QRPay,
    title: 'Nạp QRPay',
    to: DepositRouteEnum.QRPay,
    image: '/images/account/icon-menu-qr-pay.svg',
  },
  {
    method: DepositMethod.PhoneCard,
    title: 'Nạp Thẻ Cào',
    to: DepositRouteEnum.PhoneCard,
    image: '/images/account/icon-menu-phone-card.svg',
  },
  {
    method: DepositMethod.Ewallet,
    title: 'Nạp Ví Điện Tử',
    to: DepositRouteEnum.Ewallet,
    image: '/images/account/icon-menu-ewallet.svg',
  },
  {
    method: DepositMethod.Crypto,
    title: 'Nạp Crypto',
    to: DepositRouteEnum.Crypto,
    image: '/images/account/icon-menu-crypto.svg',
  },
]

export const ACCOUNT_OVERVIEW_MENUS: DepositMethodMenu[] = [
  {
    title: 'Thông tin cá nhân',
    to: AccountRouteEnum.Account,
    toMB: AccountRouteEnum.AccountInformation,
    image: '/images/account/icon-information.svg',
    imageActive: '/images/account/icon-information-active.svg',
  },
  {
    title: 'Thay đổi mật khẩu',
    to: AccountRouteEnum.ChangePassword,
    toMB: AccountRouteEnum.ChangePassword,
    image: '/images/account/icon-password.svg',
    imageActive: '/images/account/icon-password-active.svg',
  },
  {
    title: 'Quản lý ngân hàng',
    to: AccountRouteEnum.UserBank,
    toMB: AccountRouteEnum.UserBank,
    image: '/images/account/icon-user-bank.svg',
    imageActive: '/images/account/icon-user-bank-active.svg',
  },
]

export const DEPOSIT_OVERVIEW_MENUS: AccountUserOverviewMenu[] = [
  {
    name: 'Giao dịch Coin12',
    image: '/images/account/icon-menu-coin12.svg',
    imageActive: '/images/account/icon-menu-coin12-active.svg',
    to: AccountRouteEnum.TransactionCoin12,
  },
  {
    name: 'Nạp tiền',
    image: '/images/account/icon-menu-deposit.svg',
    imageActive: '/images/account/icon-menu-deposit-active.svg',
    to: DepositRouteEnum.Deposit,
    menus: [
      {
        title: 'QRPay',
        to: DepositRouteEnum.QRPay,
        image: '/images/account/icon-menu-qr-pay.svg',
        imageActive: '/images/account/icon-menu-qr-pay-active.svg',
        method: DepositMethod.QRPay,
      },
      {
        title: 'Thẻ cào',
        to: DepositRouteEnum.PhoneCard,
        image: '/images/account/icon-menu-phone-card.svg',
        imageActive: '/images/account/icon-menu-phone-card-active.svg',
        method: DepositMethod.PhoneCard,
      },
      {
        title: 'Ví điện tử',
        to: DepositRouteEnum.Ewallet,
        image: '/images/account/icon-menu-ewallet.svg',
        imageActive: '/images/account/icon-menu-ewallet-active.svg',
        method: DepositMethod.Ewallet,
      },
      {
        title: 'Crypto',
        to: DepositRouteEnum.Crypto,
        image: '/images/account/icon-menu-crypto.svg',
        imageActive: '/images/account/icon-menu-crypto-active.svg',
        method: DepositMethod.Crypto,
      },
    ],
  },
  {
    name: 'Rút tiền',
    image: '/images/account/icon-menu-withdraw.svg',
    imageActive: '/images/account/icon-menu-withdraw-active.svg',
    to: WithdrawRouteEnum.Withdraw,
    method: WithdrawMethod.Withdraw,
    menus: [
      {
        title: 'Ngân hàng',
        to: WithdrawRouteEnum.WithdrawBank,
        image: '/images/account/icon-menu-banking.svg',
        imageActive: '/images/account/icon-menu-banking-active.svg',
        method: WithdrawMethod.Banking,
      },
      {
        title: 'Thẻ cào',
        to: WithdrawRouteEnum.WithdrawPhoneCard,
        image: '/images/account/icon-menu-phone-card.svg',
        imageActive: '/images/account/icon-menu-phone-card-active.svg',
        method: WithdrawMethod.PhoneCard,
      },
      {
        title: 'Crypto',
        to: WithdrawRouteEnum.WithdrawCrypto,
        image: '/images/account/icon-menu-crypto.svg',
        imageActive: '/images/account/icon-menu-crypto-active.svg',
        method: WithdrawMethod.Crypto,
      },
    ],
  },
  {
    name: 'Lịch sử',
    image: '/images/account/icon-menu-history.svg',
    imageActive: '/images/account/icon-menu-history-active.svg',
    to: AccountRouteEnum.Transaction,
    menus: [
      {
        title: 'Lịch sử giao dịch',
        to: AccountRouteEnum.Transaction,
        image: '/images/account/icon-menu-transaction.svg',
        imageActive: '/images/account/icon-menu-transaction-active.svg',
      },
      {
        title: 'Lịch sử cá cược',
        to: AccountRouteEnum.BetHistory,
        image: '/images/account/icon-menu-betting.svg',
        imageActive: '/images/account/icon-menu-betting-active.svg',
      },
    ],
  },
  {
    name: 'Khuyến mãi của bạn',
    image: '/images/account/icon-menu-promotion.svg',
    imageActive: '/images/account/icon-menu-promotion-active.svg',
    to: AccountRouteEnum.MyPromotion,
  },
]
